var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer d-flex flex-column flex-md-row align-items-center justify-content-between"},[_c('p',{staticClass:"text-muted text-center text-md-left"},[_vm._v(" Copyright © 2021 wappin. All rights reserved ")]),_c('p',{staticClass:"text-muted text-md-right"},[_vm._v(" Version: "+_vm._s(_vm.$store.state.ui.packageVersion)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }